<template>
  <aside class="isnav">
    <a-card hoverable style="width: 256px">
      <!-- <img
        slot="cover"
        alt="example"
        :src="this.$store.state.netuser.imageurl"
      /> -->
      <template slot="actions">
        <router-link to="/User/accountsettings"><a-icon key="setting" type="setting" /></router-link>

        <router-link to="/User/sendtelegraph"><a-icon key="edit" type="edit" /></router-link>
        <a-icon key="bell" type="bell" />
              <!-- <a-icon key="ellipsis" type="ellipsis" /> -->
      </template>

      <a-card-meta
        :title="this.$store.state.netuser.name"
        :description="this.$store.state.netuser.introduce"
      >
        <a-avatar slot="avatar" :src="this.$store.state.netuser.imageurl" />
      </a-card-meta>
    </a-card>
    <div>
      <a-menu
        mode="inline"
        :open-keys="openKeys"
        style="width: 256px"
        @openChange="onOpenChange"
        :default-selected-keys="['0']"
      >
        <a-menu-item key="0">
         <router-link to="/User/index"> <a-icon type="home"  /><span>个人首页</span></router-link>
        </a-menu-item>
        <a-sub-menu key="sub1">
          <span slot="title"><a-icon type="user" /><span>账号信息</span></span>
          <a-menu-item key="1"><router-link to="/User/pi"> 个人资料 </router-link></a-menu-item>
          <a-menu-item key="2"><router-link to="/User/accountmessage"> 账号设置 </router-link></a-menu-item>
          <a-menu-item key="3"><router-link to="/User/privacy"> 隐私设置 </router-link></a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub2">
          <span slot="title"
            ><a-icon type="container" /><span>发布管理</span></span
          >
          <a-menu-item key="4"><router-link to="/User/release/telegraphs"> 发布列表 </router-link></a-menu-item>
          <a-menu-item key="5"><router-link to="/User/release/send"> 添加发布 </router-link></a-menu-item>
          <a-menu-item key="6"><router-link to="/User/release/draft"> 草稿列表</router-link> </a-menu-item>
          <!-- <a-sub-menu key="sub3" title="Submenu">
            <a-menu-item key="7"> Option 7 </a-menu-item>
            <a-menu-item key="8"> Option 8 </a-menu-item>
          </a-sub-menu> -->
        </a-sub-menu>
        <a-sub-menu key="sub4">
          <span slot="title"
            ><a-icon type="menu" /><span>专栏管理</span></span
          >
          <a-menu-item key="7"><router-link to="/User/sort"> 专栏列表 </router-link> </a-menu-item>
          <a-menu-item key="8"><router-link to="/User/sort/addstory"> 添加专栏 </router-link></a-menu-item>
        </a-sub-menu>
                <a-sub-menu key="sub5">
          <span slot="title"
            ><a-icon type="bell" /><span>消息管理</span></span
          >
          <a-menu-item key="9"><router-link to="/User/clientmessage"> 站内信息 </router-link></a-menu-item>
          <a-menu-item key="10"><router-link to="/User/supermessage"> 系统消息 </router-link></a-menu-item>
          <a-menu-item key="11"><router-link to="/User/privatemessage"> 私信信息 </router-link></a-menu-item>
        </a-sub-menu>
      </a-menu>
    </div>
  </aside>
</template>
<script>
import telegraphs from './release/telegraphs/telegraphs.vue';
export default {
  components: { telegraphs },
  name: "isnav",
  data() {
    return {
      // username: this.$store.state.netuser.netUserName,
      // userimage: this.$store.state.netuser.netUserImage,

      rootSubmenuKeys: ["sub1", "sub2", "sub4"],
      openKeys: ["sub1", "sub2", "sub4"],
    };
  },

  mounted() {},

  methods: {
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    //   linked(id){
    //       this.$router.push({name: '', params:{这里写携带的参数}})
    //   }
  },

  watch: {},
};
</script>

<style lang="less" scoped>
//  用户详情栏
.isnav {
  width: 300px;
  // background-color: blueviolet;
  figure {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5px;
    img {
      border-radius: 50% 50%;
      width: 20%;
      height: 20%;
      z-index: 3;
    }
    figcaption {
      display: inline-block;
      max-width: 80%;
      min-width: 80%;
      padding-left: 10px;
      z-index: 1;
      h1 {
        padding-top: 8%;
        margin-bottom: 0.3rem;
        width: max-content;
        font-size: 23px;
        color: slateblue;
      }
      p {
        width: fit-content;
        text-indent: 2em;
        text-align: left;
        letter-spacing: 1px;
        word-wrap: break-word;
      }
    }
    ul {
      position: relative;
      width: 100%;
      height: 50px;
      top: -49px;
      // background-color: rgb(39, 134, 218);
      line-height: 50px;
      border-radius: 0 50% 50% 0;
      z-index: 2;
      li {
        margin-right: 10%;
        float: right;
      }
    }
  }
  // .router-link-exact-active {
  //   font-size: 23px;
  //   color: blueviolet;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/nav.vue